// URL Rewriter Utility
let isInitialized = false;
let mutationObserver = null;

export function initUrlRewriter() {
  // Prevent multiple initializations
  if (isInitialized) {
    console.log("URL Rewriter already initialized, skipping...");
    return;
  }

  isInitialized = true;
  const version = Date.now();

  const NEW = "https://devrw2.blob.core.windows.net/rw-website/assets/";
  const OLD_PATTERN =
    /https:\/\/devrw\.blob\.core\.windows\.net\/rw-website\/assets\//g;

  function rewriteString(s) {
    return s && typeof s === "string" ? s.replace(OLD_PATTERN, NEW) : s;
  }

  function rewriteElement(el) {
    if (!el || el.nodeType !== 1) return;
    try {
      console.log("Rewriting element:", el);
      console.log("Before rewrite:", el.outerHTML);
      console.log("Version:", version);
      ["src", "href"].forEach((attr) => {
        if (el.hasAttribute && el.hasAttribute(attr)) {
          const val = el.getAttribute(attr);
          const rewritten = rewriteString(val);
          if (rewritten !== val) el.setAttribute(attr, rewritten);
        }
      });

      // Rewrite inline styles
      if (el.style?.backgroundImage) {
        const bg = el.style.backgroundImage;
        const updated = rewriteString(bg);
        if (updated !== bg) el.style.backgroundImage = updated;
      }

      // Rewrite other attributes
      Array.from(el.attributes || []).forEach((attr) => {
        if (attr?.value && OLD_PATTERN.test(attr.value)) {
          el.setAttribute(attr.name, attr.value.replace(OLD_PATTERN, NEW));
        }
      });
    } catch (e) {
      console.error("URL rewrite error:", e);
    }
  }

  function rewriteAll(root) {
    try {
      (root || document)
        .querySelectorAll("[src],[href],[style],[data-src],[data-background]")
        .forEach(rewriteElement);
    } catch (e) {}
  }

  // Since we're called from useEffect, DOM is already ready
  rewriteAll(document);

  try {
    // Disconnect existing observer if any (shouldn't happen, but safety check)
    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.addedNodes?.length) {
          m.addedNodes.forEach((n) => {
            if (n.nodeType === 1) {
              rewriteElement(n);
              n.querySelectorAll?.(
                "[src],[href],[style],[data-src],[data-background]"
              ).forEach(rewriteElement);
            }
          });
        }
        if (m.type === "attributes" && m.target) rewriteElement(m.target);
      });
    });

    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src", "href", "style", "data-src", "data-background"],
    });
  } catch (e) {
    console.error("Failed to set up MutationObserver:", e);
  }
}
